import { render, staticRenderFns } from "./AddressCheck.vue?vue&type=template&id=40701e2a&scoped=true&"
import script from "./AddressCheck.vue?vue&type=script&lang=js&"
export * from "./AddressCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40701e2a",
  null
  
)

export default component.exports